import Header from "../../Components/Layout/Header/Header";
import Footer from "../../Components/Layout/Footer/Footer";
import "./EventTicket.scss";
import React, { useState, useEffect, useReducer } from "react";
import moment from "moment";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import combinedServices from "../../shared/services/user-service";
import userConstants from "../../shared/constants/user-constants";
import swal from "sweetalert";
import EditJoinRace from "./UpdateTicket";

import getRemoveData from "../../shared/localStorage/removeData";
import getLocalData from "../../shared/localStorage/getData";
import { Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { lightGreen } from "@mui/material/colors";
import EditableForm from "../AddEvent/editTransponders";
import CryptoJS from "crypto-js";
import { useSetRecoilState } from "recoil";
import { ticketCartCountState } from "../../Pages/NambaStore/state/cartState";
const secretKey = userConstants.CRYPTOSECRETKEY;

const EventTicket = () => {
  const setTicketCount = useSetRecoilState(ticketCartCountState);
  const params = useParams();
  let navigate = useNavigate();
  const [eventId, setEventId] = useState("");
  const [eventDetails, setEventDetails] = useState([]);
  const [eventClassDetails, setEventClassDetails] = useState([]);
  const [registrationCount, setRegistrationCount] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [classIds, setClassIds] = useState([]);
  const [total, setTotal] = useState("");
  const [baseURL, setBaseUrl] = useState(userConstants.baseURL);
  const [handicappedPitSpace, setHandicappedPitSpace] = useState(false);
  const [hostClubName, setHostClubName] = useState("");
  const [subMember, setSubMember] = useState([]);
  const [selectedSubMemberId, setSelectedSubMemberId] = useState(0);
  const [selectedSubMember, setSelectedSubMember] = useState("");
  const [selectedSubMemberAndClass, setSelectedSubMemberAndClass] = useState(
    []
  );
  const [participantIds, setParticipantIds] = useState("");
  const [editEntryRaceButton, setEditEntryRaceButton] = useState(false);
  const [specialNote, setSpecialNote] = useState("");
  const [searchUser, setSearchUser] = useState([]);
  const [maxEnteries, setMaxEnteries] = useState(0);
  const [userID, setUserId] = useState("");
  const [authoriseduser, setAuthorisedUser] = useState([]);
  const [contestdir, setContestDir] = useState("");
  const [addEntr, setAddEntr] = useState(false);
  const [transponders, setTransponders] = useState([]);
  const [editopen, setEditOpen] = React.useState(false);
  const [disabledall, setDisabledAll] = React.useState(true);

  const [selectedTransponder, setSelectedTransponder] = useState([]);
  const [inputbox, setInputbox] = useState(false);
  const [classinput, setClassinput] = useState(false);
  const [transponderAllow, setTransponderallow] = useState(false);
  const [deleteUser, setDeleteUser] = useState(false);

  const [userName, setUserName] = useState("");
  const [isRegistrationValid, setIsRegistrationValid] = useState(false);
  const [cartTicketitem, setCartticketitem] = useState([]);

  const secretKey = userConstants.CRYPTOSECRETKEY;

      const location = useLocation();
      const storeID = location.state?.storeID;

  useEffect(async () => {
    if (getLocalData("user_info", "isLogin")) {
      var userId = getLocalData("user_info", "all").userData.login_user_detail
        .data.user.id;

      setUserId(userId);
    }
    // Remove the initial hide of user list
    // var ele = document.getElementById("toggleText");
    // ele.style.display = "none";

    var paymentArr = [];
    setEventId(params.id);
    let eventResponse = await combinedServices.getEventDetail(params.id);
    if (eventResponse.status == 401) {
      swal(eventResponse.msg, "Please Re-login", "warning").then(() => {
        getRemoveData("user_info");
        localStorage.clear();
        window.location.href = "/login";
      });
    }

    let eventDetail = eventResponse.data;
    var event_contact = eventDetail.event_contacts.split(",");

    var data = {
      authorizatized: eventDetail.event_authorized_user_ids,
      event_updatedBy: eventDetail.event_updated_by
    };
    setAuthorisedUser(data.authorizatized);
    setContestDir(data.event_updatedBy);
    // setEventDetails(data);
    if (
      userId === data.event_updatedBy ||
      data.authorizatized.includes(userId)
    ) {
      setAddEntr(true);
    }

    let eventClassResponse = await combinedServices.getClassByEvent(params.id);
    if (eventClassResponse.status == 401) {
      swal(eventClassResponse.msg, "Please Re-login", "warning").then(() => {
        getRemoveData("user_info");
        localStorage.clear();
        window.location.href = "/login";
      });
    }

    //let eventSubMember = await combinedServices.getAllSubMemberList(localStorage.getItem("parent_token"));
    let eventSubMember = await combinedServices.getAllSubMemberList(
      localStorage.getItem("parent_token")
    );
    if (eventSubMember.status == 401) {
      swal(eventSubMember.msg, "Please Re-login", "warning").then(() => {
        getRemoveData("user_info");
        localStorage.clear();
        window.location.href = "/login";
      });
    }

    if (eventSubMember.status == 200) {
      //setSubMember(eventSubMember.data);
      var userLIst = [];
      eventSubMember.data.map((user) => {
        if (user.user_status === "active") {
          var data = {
            name: user.user_firstname + " " + user.user_lastname,
            id: user.id
          };

          userLIst.push(data);
        }
      });

      setSubMember(userLIst);
      
      // Auto-select and auto-click first user after 500ms
      if (userLIst.length > 0) {
        const firstUser = userLIst[0];
        setTimeout(() => {
          // First call the handleSubUser function
          handleSubUser(firstUser);
          
          // Then simulate a click on the first member option after DOM is ready
          setTimeout(() => {
            const firstMemberOption = document.querySelector('.member-option');
            if (firstMemberOption) {
              firstMemberOption.click();
            }
          }, 100);
        }, 500);
      }
    }

    if (eventClassResponse.data.event.allow_mail_ins) {
      paymentArr.push("Payment By Mail");
    }
    if (eventClassResponse.data.event.allow_pay_at_race_entries) {
      paymentArr.push("Payment At Race");
    }
    if (eventClassResponse.data.event.allow_paypal_entries) {
      paymentArr.push("PayPal");
    }
    setPaymentMethod(paymentArr);

    setHostClubName(eventClassResponse.data.event.host_club.club_name);
    console.log("eventclassresponse", eventClassResponse);
    setEventDetails(eventClassResponse.data.event);
    const today = new Date();
    const registrationOpenDate = new Date(
      eventClassResponse.data.event.registration_open
    );
    const registrationCloseDate = new Date(
      eventClassResponse.data.event.registration_close
    );

    if (today >= registrationOpenDate && today <= registrationCloseDate) {
      // Registration is open within the valid range
      setIsRegistrationValid(true);
      console.log("Registration is open");
    } else {
      // Registration is closed (either too early or too late)
      setIsRegistrationValid(false);
      console.log("Registration is closed");
    }

    setMaxEnteries(eventClassResponse.data.event.max_enteries);
    setTransponderallow(eventClassResponse.data.event.transponder_allow);
    const sortedClasses = eventClassResponse.data.eventClasses.sort((a, b) => {
      if (a.class_Class_Name < b.class_Class_Name) return -1;
      if (a.class_Class_Name > b.class_Class_Name) return 1;
      return 0;
    });
    setEventClassDetails(sortedClasses);
    // const res = await combinedServices.getTransponders({ event_id: params.id });
    // setTransponders(res.data);
  }, []);

  useEffect(async () => {
    const encryptedEventData = localStorage.getItem("EventcartData");
    if (encryptedEventData) {
      const decryptedOrderId = CryptoJS.AES.decrypt(
        encryptedEventData,
        secretKey
      ).toString(CryptoJS.enc.Utf8);
      const parsedDecryptedData = JSON.parse(decryptedOrderId);
      console.log("parsedDecryptedData", parsedDecryptedData);
      setCartticketitem(parsedDecryptedData);
    } else {
      console.log("Data not available in local storage");
    }
  }, []);

  const encryptOrderId = (newArr) => {
    console.log(newArr);
    return CryptoJS.AES.encrypt(newArr, secretKey).toString();
  };

  const handleRegistionCost = (e, class_id, class_name, index) => {
    console.log("e", e, "class_id", class_id, "class_name", class_name, "index", index);
    
    if (class_id && inputbox === true && transponderAllow == 1) {
      setClassinput(true);
    }
  
    var newClassArry = [...classIds];
    var totalClasses = registrationCount;
  
    if (e.target.checked) {
      var data = {
        id: class_id,
        name: class_name,
        index
      };
      newClassArry.push(data);
      totalClasses = totalClasses + 1;
    } else {
      var indexToRemove = newClassArry.findIndex(item => item.id === class_id);
      if (indexToRemove !== -1) {
        newClassArry.splice(indexToRemove, 1);
      }
      totalClasses = totalClasses - 1;
    }
  
    setClassIds(newClassArry);
    setRegistrationCount(totalClasses);
  
    // Calculate total cost
    if (totalClasses === 0) {
      setTotal("");
    } else {
      const totalCost = Number(eventDetails.registration_charge) + 
                        (Number(eventDetails.boat_charge) * totalClasses);
      setTotal(totalCost.toFixed(2));
    }
  };

  const handleTransponderChange = (e, index) => {
    const newTransponder = [...selectedTransponder];
    const selectedDetails = JSON.parse(e.target.value);

    const data = { ...selectedDetails, index };
    // Check if the index is within the valid range
    let existingIndex = newTransponder.findIndex(
      (item) => item.index === data.index
    );
    if (existingIndex !== -1) {
      // Update existing object
      newTransponder[existingIndex] = data;
    } else {
      // Push new object
      newTransponder.push(data);
    }
    // if (index >= 0 && index < newTransponder.length) {
    //   // Replace the object at the specified index with the new object
    //   newTransponder[index] = data;
    // } else {
    //   // Add the new transponder to the array if the index is out of range
    //   newTransponder.push(data);
    // }

    // Update the state
    setSelectedTransponder(newTransponder);

    // Assuming transponderAllow and selectedTransponder are defined
    if (selectedTransponder.length > 0 && transponderAllow === 1) {
      setClassinput(false);
    }
  };

  const calculateDaysBetweenTwoDate = () => {
    var future = moment(eventDetails.registration_close);
    var start = moment(eventDetails.registration_open);
    var d = future.diff(start, "days") + 1; // 9

    return d;
  };

  const handleSubUser = async (user) => {
    if (user != "") {
      setDisabledAll(false);
    }
    setInputbox(true);
    setSelectedSubMemberId(user.id);
    setUserName(user.name);
    setUserId(user.id);

    document.getElementById("searchUser").value = user.name;
    // Remove the hide logic - list should stay visible

    var registeredData = {
      event_id: eventId,
      user_id: user.id
    };

    let registeredUser = await combinedServices.checkIfUserJoined(
      registeredData
    );
    if (registeredUser.status === 404) {
      const targetEventId = parseInt(registeredData.event_id, 10);
      const targetUserId = registeredData.user_id;

      const matchingEntries = cartTicketitem.filter(
        (item) =>
          item.user_id === targetUserId && item.event_id === targetEventId
      );

      const existingClassIds = matchingEntries.flatMap((entry) =>
        entry.selectedClass.map((cls) => ({ id: cls.id, name: cls.name }))
      );

      // Process each existing class
      existingClassIds.forEach((classObj, i) => {
        setTimeout(() => {
          const simulatedEvent = { target: { checked: true } };
          handleeditcart(simulatedEvent, classObj.id, classObj.name, 1);
        }, ); // delay each call slightly
      });

      console.log("Processed classes:", existingClassIds);
      console.log("Matching entries:", matchingEntries);
    }
    setUserId(registeredData.user_id);
    let response = await combinedServices.getTransponders(
      registeredData.user_id
    );
    setTransponders(response.data.data);

    if (registeredUser.status == 200) {
      setParticipantIds(registeredUser.data.id);
      setEditEntryRaceButton(true);
      //navigate("../event/update-join-event/" + registeredUser.data.id, { replace: true });
      // swal("!Opps", "Member is already registered in this event", "error") ;
      //setEditEntryRaceButton(true) ;
    } else {
      setEditEntryRaceButton(false);
      //setParticipantIds(registeredUser.data.id)

      //var country_select = document.querySelector("#sub_member_name");
      //var user_name = country_select.options[country_select.selectedIndex].getAttribute('user_name');
      setSelectedSubMember(user.name);
    }
  };

  const handleeditcart = (e, class_id, class_name, index) => {
    setClassIds(prevClassIds => {
      // Create new array from previous state
      const newClassArry = [...prevClassIds];
      const existingIndex = newClassArry.findIndex(item => item.id === class_id);
  
      if (e.target.checked) {
        // Add class if checked and not already present
        if (existingIndex === -1) {
          newClassArry.push({
            id: class_id,
            name: class_name,
            index
          });
        }
      } else {
        // Remove class if unchecked and present
        if (existingIndex !== -1) {
          newClassArry.splice(existingIndex, 1);
        }
      }
  
      // Calculate new count based on the updated array
      const newCount = newClassArry.length;
      
      // Calculate total cost
      let totalCost = 0;
      if (newCount > 0) {
        totalCost = Number(eventDetails.registration_charge) + 
                   (Number(eventDetails.boat_charge) * newCount);
      }
  
      // Update dependent states
      setTotal(totalCost.toFixed(2));
      setRegistrationCount(newCount);
  
      return newClassArry;
    });
  };

  const handleSubUserAndClass = async () => {
    setInputbox(false);
    if (selectedSubMemberId == 0) {
      return swal("!Opps", "Please select member first ", "error");
    }

    // 🔹 Retrieve and decrypt existing data from localStorage
    let existingData = localStorage.getItem("EventcartData");
    let newArr = [];

    if (existingData) {
      try {
        const decryptedData = CryptoJS.AES.decrypt(
          existingData,
          secretKey
        ).toString(CryptoJS.enc.Utf8);
        newArr = JSON.parse(decryptedData) || [];
      } catch (error) {
        console.error("Error decrypting localStorage data:", error);
        newArr = [];
      }
    }

    // 🔹 Create new entry
    let data = {
      user_name: selectedSubMember,
      user_id: Number(selectedSubMemberId),
      classWiseTotal: total,
      pit_space: Boolean(handicappedPitSpace),
      special_note: specialNote,
      event_name: eventDetails.full_title,
      event_id: eventDetails.id,
      store_id: storeID
    };

    if (transponderAllow == 1) {
      const classIndexes = classIds.map(({ index }) => index);
      const transponderIndexes = selectedTransponder.map(({ index }) => index);

      const allClassIndexesInTransponders = classIndexes.every((classIndex) =>
        transponderIndexes.includes(classIndex)
      );

      if (!allClassIndexesInTransponders) {
        return swal("!Opps", "Please select Transponder ", "error");
      }

      data.selectedClass = selectedTransponder
        .filter(({ index }) => classIndexes.includes(index))
        .map(({ index, id, transponder_name }) => ({
          class_id: classIds.find((classObj) => classObj.index === index).id,
          transponder_id: id,
          transponder_name
        }));
    } else {
      data.selectedClass = classIds;
      data.image = eventDetails.image;
    }

    // 🔹 Remove existing entry if `user_id` & `event_name` match
    newArr = newArr.filter(
      (entry) =>
        !(
          entry.user_id === data.user_id && entry.event_name === data.event_name
        )
    );

    // 🔹 Add new entry
    newArr.push(data);
    setSelectedSubMemberAndClass(newArr);
console.log("newArr", newArr,eventDetails);
    // 🔹 Encrypt and update localStorage
    const encryptedOrderId = CryptoJS.AES.encrypt(
      JSON.stringify(newArr),
      secretKey
    ).toString();
    setSpecialNote("");
    localStorage.setItem("EventcartData", encryptedOrderId);
    setTicketCount(newArr.length);

    swal({
      title: "Success",
      text: "Added to cart successfully",
      icon: "success",
      buttons: {
        confirm: {
          text: "Ok",
          value: "store",
          visible: true,
          className: "swal-button--confirm"
        },
      }
    }).then((value) => {
      console.log("User clicked:", value);
      switch (value) {
        case "store":
          navigate("/productListing",{ state: { storeID } });
          break;

        case "add_more":
          console.log("User wants to add more participants");
          break;

        default:
          break;
      }
    });
    // 🔹 Updating eventClassDetails
    const classIDMap = {};
    for (const classEntry of eventClassDetails) {
      classIDMap[classEntry.class_Class_Name_ID] = classEntry;
    }

    for (const selectedClass of data.selectedClass) {
      const classEntry = classIDMap[selectedClass.id];
      if (classEntry) {
        classEntry.entriesCount = Number(classEntry.entriesCount) + 1;
      }
    }

    // 🔹 Reset inputs
    // document
    //   .querySelectorAll(".checkInpt")
    //   .forEach((input) => (input.checked = false));
    setClassIds([]);
    setSelectedTransponder([]);
    setTotal(0);
    setSelectedSubMember("");
    setSelectedSubMemberId(0);
    setRegistrationCount(0);
    setHandicappedPitSpace(false);
    setTransponders([]);
    document.getElementById("searchUser").value = "";
  };

  const handleSpecialNotes = (e) => {
    setSpecialNote(e.target.value);
  };

  const handleSearchBox = (e) => {
    setSearchUser(e.target.value);
    // Remove the toggle logic - list should always be visible
    if (e.target.value != "") {
      setInputbox(true);
      setDeleteUser(false);
    }
    setClassinput(false);
  };

  const handleclickopen1 = () => {
    setEditOpen(true);
  };

  const handleClose2 = async () => {
    setEditOpen(false);
    let response = await combinedServices.getTransponders(userID);
    setTransponders(response.data.data);
  };

  const handleStoreNavigation = (e) => {
    e.preventDefault();
    navigate("/productListing", { state: { storeID } });
  };

  const refreshEventClassDetails = async (selectedClasses, unselectedClasses) => {

    console.log("selected & unselected classes is ", selectedClasses, unselectedClasses);

    // Update entry counts based on selected/unselected classes
    const updatedClassDetails = [...eventClassDetails];
    
    // Increment count for selected classes
    selectedClasses.forEach(classId => {
      const classEntry = updatedClassDetails.find(c => c.class_Class_Name_ID === classId);
      if (classEntry) {
        classEntry.entriesCount = Number(classEntry.entriesCount) + 1;
      }
    });
    
    // Decrement count for unselected classes
    unselectedClasses.forEach(classId => {
      const classEntry = updatedClassDetails.find(c => c.class_Class_Name_ID === classId);
      if (classEntry) {
        classEntry.entriesCount = Number(classEntry.entriesCount) - 1;
      }
    });
    
    setEventClassDetails(updatedClassDetails);
  };

  return (
    <>
      <div className="mainCon">
        <Header />
        <div className="innerBanner event">
          <div className="container flexBox">
            <div>
              <div className="innerHd">Events</div>
              <div className="bradcrumb">
                <a href="/">Home</a>
                <a href="#" onClick={handleStoreNavigation}>Store</a>
              </div>
            </div>
          </div>
        </div>

        <div className="pb50 grayBg">
          <div className="container">
            <div className="whtBox">
              <div className="addEventTop flexBox spacebetween itemCenter">
                <div className="left flexBox itemCenter nowrap">
                  <img
                    src={
                      eventDetails?.image?.startsWith("https://nambaweb")
                        ? eventDetails.image
                        : baseURL + "images/" == eventDetails.image
                        ? "https://nambaweb.s3.ap-south-1.amazonaws.com/frontend-static-image/logo.png"
                        : eventDetails.image
                    }
                    alt=""
                  />
                  {eventDetails.full_title}
                  <br />
                  {hostClubName}
                </div>

                <div className="right">
                  Registration In -{" "}
                  {moment(eventDetails.registration_open).format("MMM Do")} -{" "}
                  {moment(eventDetails.registration_close).format("MMM Do")}
                  {calculateDaysBetweenTwoDate() > 0
                    ? "," + calculateDaysBetweenTwoDate() + " days"
                    : ""}
                  <br />
                </div>
              </div>

              <form id="myForm">
                <div className="addEventMid">
                  <div className="paymentMetHd">Members INFORMATION</div>
                  <div className="eventInner">
                    <div className="lft">Members</div>
                    <div className="rgt">
                      <div className="eventInner searchBox membersList-box">
                        <div className="member-selector-wrapper">
                          <div className="selected-member-display">
                            <div className="member-info">
                              <span className="member-icon">👤</span>
                              <div className="member-details">
                                <input
                                  type="text"
                                  className="searchUser selected-member-input"
                                  id="searchUser"
                                  placeholder="Search or select a member"
                                  onChange={handleSearchBox}
                                  onClick={handleSearchBox}
                                  autoComplete="off"
                                />
                                <div className="member-count-info">
                                  <span className="total-members">{subMember.length} members available</span>
                                  <span className="selection-hint">Click to see all options ↓</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          
                          <div className="members-dropdown" id="toggleText">
                            <div className="dropdown-header">
                              <span className="dropdown-title">Select Member ({subMember.length} available)</span>
                            </div>
                            <div className="members-list-container">
                              {subMember
                                .filter((val) => {
                                  if (searchUser == "") {
                                    return val;
                                  } else if (
                                    val.name
                                      .toLowerCase()
                                      .includes(searchUser.toLowerCase())
                                  ) {
                                    return val;
                                  }
                                })
                                .map((user, index) => (
                                  <div 
                                    key={`${user.id}-${index}`} 
                                    className={`member-option ${selectedSubMemberId === user.id ? 'selected' : ''}`}
                                    onClick={() => handleSubUser(user)}
                                  >
                                    <span className="member-avatar">👤</span>
                                    <span className="member-name">{user.name}</span>
                                    {selectedSubMemberId === user.id && (
                                      <span className="selected-indicator">✓</span>
                                    )}
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {editEntryRaceButton ? (
                  <EditJoinRace
                    participateId={participantIds}
                    eventName={eventDetails.id}
                    userID={userID}
                    isregistrationopne={isRegistrationValid}
                    storeId={storeID}
                    eventClassDetails={eventClassDetails} 
                    onEntryUpdated={refreshEventClassDetails}
                  />
                ) : (
                  <div className="addEventMid">
                    <div className="addEventTable">
                      <table>
                        <tr>
                          <th>CLASS</th>
                          {transponderAllow == 1 ? (
                            <th>TRANSPONDER</th>
                          ) : (
                            <th></th>
                          )}
                          <th>ENTRIES COUNT </th>
                        </tr>
                        {eventClassDetails.map((distVal, index) => {
                          const isMaxEntriesReached =
                            distVal.entriesCount == maxEnteries || (distVal.eventClass_isLimitApplied && Number(distVal.entriesCount)+1 > distVal.eventClass_maximum_entries_per_class);
                          if (maxEnteries > 0) {
                            return (
                              <tr index={index}>
                                <td>
                                  <input
                                    type="checkbox"
                                    className="checkInpt"
                                    onChange={(e) =>
                                      handleRegistionCost(
                                        e,
                                        distVal.class_Class_Name_ID,
                                        distVal.class_Class_Name,
                                        index
                                      )
                                    }
                                    disabled={
                                      isMaxEntriesReached
                                      //  ||
                                      // selectedSubMemberId === 0
                                    }
                                  />
                                  {distVal.class_Class_Name}
                                  {/* {distVal.class_Class_Name_ID} */}
                                </td>

                                {transponderAllow == 1 ? (
                                  <td>
                                    <div
                                      className="smllInput"
                                      style={{ display: "flex" }}
                                    >
                                      <div
                                        className="listLeft"
                                        style={{
                                          width: "70%",
                                          textAlign: "initial"
                                        }}
                                      >
                                        <ul
                                          // className="flexBox eventForm"
                                          disabled={selectedSubMemberId === 0}
                                        >
                                          <li>
                                            {/* <div className="rgt"> */}
                                            <select
                                              className="formSelect"
                                              id="sub_member_name"
                                              onChange={(e) =>
                                                handleTransponderChange(
                                                  e,
                                                  index
                                                )
                                              }
                                            >
                                              <option value="">
                                                Select Transponder
                                              </option>
                                              {transponders.length > 0
                                                ? transponders.map((value) => {
                                                    return (
                                                      <option
                                                        key={value.id}
                                                        value={JSON.stringify(
                                                          value
                                                        )}
                                                        disabled={
                                                          value.user_status ==
                                                          "inactive"
                                                            ? "disabled"
                                                            : ""
                                                        }
                                                        user_name={
                                                          value.user_firstname +
                                                          " " +
                                                          value.user_lastname
                                                        }
                                                      >
                                                        {value.transponder_name +
                                                          " - " +
                                                          "(" +
                                                          value.id +
                                                          ")"}{" "}
                                                      </option>
                                                    );
                                                  })
                                                : ""}
                                            </select>
                                            {/* </div> */}
                                          </li>
                                        </ul>
                                        {/* </div> */}
                                      </div>
                                      <div
                                        style={{
                                          width: "30%",
                                          paddingRight: "5px",
                                          textAlign: "initial"
                                        }}
                                      >
                                        <Button
                                          variant="outlined"
                                          onClick={handleclickopen1}
                                        >
                                          +
                                        </Button>

                                        <Dialog
                                          open={editopen}
                                          onClose={handleClose2}
                                        >
                                          <DialogTitle>
                                            Transponders
                                            <IconButton aria-label="delete">
                                              <EditIcon />
                                            </IconButton>
                                            <IconButton aria-label="delete">
                                              <DeleteIcon />
                                            </IconButton>
                                          </DialogTitle>
                                          <DialogContent>
                                            <EditableForm
                                              data={selectedSubMemberId}
                                            />
                                          </DialogContent>
                                          <DialogActions>
                                            <Button onClick={handleClose2}>
                                              Save
                                            </Button>
                                          </DialogActions>
                                        </Dialog>
                                      </div>
                                    </div>
                                  </td>
                                ) : (
                                  <td></td>
                                )}

                                <td>
                                  {distVal.entriesCount
                                    ? distVal.entriesCount + "/" + maxEnteries
                                    : 0 + "/" + maxEnteries}
                                </td>
                              </tr>
                            );
                          } else {
                            return (
                              <tr index={index}>
                                <td>
                                  <input
                                    type="checkbox"
                                    className="checkInpt"
                                    name="checkInpt"
                                    checked={classIds.some(
                                      (item) =>
                                        item.id === distVal.class_Class_Name_ID // Match class ID
                                    )}
                                    onChange={(e) =>
                                      handleRegistionCost(
                                        e,
                                        distVal.class_Class_Name_ID,
                                        distVal.class_Class_Name,
                                        index
                                      )
                                    }
                                    // disabled={
                                    //   selectedSubMemberId===0
                                    // }
                                    disabled={distVal.eventClass_isLimitApplied && Number(distVal.entriesCount)+1 > distVal.eventClass_maximum_entries_per_class}
                                  />

                                  {distVal.class_Class_Name}
                                </td>
                                {transponderAllow == 1 ? (
                                  <td>
                                    <div
                                      className="smllInput"
                                      style={{ display: "flex" }}
                                    >
                                      <div
                                        className="listLeft"
                                        style={{
                                          width: "70%",
                                          textAlign: "initial"
                                        }}
                                      >
                                        <ul
                                          // className="flexBox eventForm"
                                          disabled={selectedSubMemberId === 0}
                                        >
                                          <li>
                                            <select
                                              className="formSelect"
                                              id="sub_member_name"
                                              onChange={(e) =>
                                                handleTransponderChange(
                                                  e,
                                                  index
                                                )
                                              }
                                            >
                                              <option value="">
                                                Select Transponder
                                              </option>
                                              {transponders?.length > 0
                                                ? transponders?.map((value) => {
                                                    return (
                                                      <option
                                                        key={value.id}
                                                        value={JSON.stringify(
                                                          value
                                                        )}
                                                        disabled={
                                                          value.user_status ==
                                                          "inactive"
                                                            ? "disabled"
                                                            : ""
                                                        }
                                                        user_name={
                                                          value.user_firstname +
                                                          " " +
                                                          value.user_lastname
                                                        }
                                                      >
                                                        {value.transponder_name +
                                                          " - " +
                                                          "(" +
                                                          value.id +
                                                          ")"}{" "}
                                                      </option>
                                                    );
                                                  })
                                                : ""}
                                            </select>
                                          </li>
                                        </ul>
                                        {/* </div> */}
                                      </div>
                                      <div
                                        style={{
                                          width: "30%",
                                          paddingRight: "5px",
                                          textAlign: "initial"
                                        }}
                                      >
                                        <Button
                                          variant="outlined"
                                          onClick={handleclickopen1}
                                        >
                                          +
                                        </Button>

                                        <Dialog
                                          open={editopen}
                                          onClose={handleClose2}
                                        >
                                          <DialogTitle>
                                            Transponders
                                          </DialogTitle>
                                          <DialogContent>
                                            <EditableForm
                                              data={selectedSubMemberId}
                                            />
                                          </DialogContent>
                                          <DialogActions>
                                            <Button onClick={handleClose2}>
                                              Save
                                            </Button>
                                          </DialogActions>
                                        </Dialog>
                                      </div>
                                    </div>
                                  </td>
                                ) : (
                                  <td></td>
                                )}
                                <td>
                                  {distVal.entriesCount
                                    ? distVal.entriesCount
                                    : 0}
                                </td>
                              </tr>
                            );
                          }
                        })}
                        <tr className="paymentMetHd">
                          <td>Total</td>
                          <td></td>

                          <td>{total}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                )}
              </form>

              {!editEntryRaceButton && (
                <>
                  <div className="eventDetBot">
                    <div className="paymentMetHd">Special Note BY Member</div>
                    <div className="eventInner">
                      <ul className="flexBox eventForm">
                        <li className="full">
                          <textarea
                            rows="4"
                            cols="12"
                            className="formInput"
                            name="contacts"
                            value={specialNote}
                            onChange={handleSpecialNotes}
                          ></textarea>
                          <div className="exText">
                            Please enter only one contact name and number per
                            line.
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="addEventBot">
                    <div className="paymentType">
                      <div className="addEventBot">
                        <>
                          <button
                            type="button"
                            className="continueBtn"
                            onClick={handleSubUserAndClass}
                            // disabled={!selectedSubMemberId}
                          >
                            Add To Ticket Cart
                          </button>
                        </>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};
export default EventTicket;
